import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import api from '../../views/services/api';
import { ACCOUNT_INITIALIZE } from '../../store/actions';
// import { ACCOUNT_INITIALIZE } from '../../store/actions';

const AuthInit = ({ children }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const token = localStorage.getItem('access_token');

        if (token) {
            // garante header global
            api.defaults.headers.Authorization = `Bearer ${token}`;

            dispatch({
                type: ACCOUNT_INITIALIZE,
                payload: {
                    isLoggedIn: true,
                    token
                }
            });
        }
    }, [dispatch]);

    return children;
};

export default AuthInit;
